<template>
   <div class="page-wrapper">
       <div class="movie-box page-margin-top3 page-text-center size">
           ！请在微信客户端打开
       </div>
   </div>
</template>

<script>
import { isWeixin } from "@utils";
export default {
    name: "NotWechat",
    created: function () {
        if (isWeixin()) {
            this.$router.replace('/');
        }
    }
}
</script>

<style scoped>
.size {
    font-size: .34rem;
    line-height: 1rem;
}
</style>